import { SchoolBlogData } from '../../../../../util/type/School/SchoolBlogData.type';
import { SchoolDetailBlogInputType } from '../type/Blog/SchoolDetailBlogInput.type';

export const schoolBlogTolBlogInputData = (schoolBlogData: SchoolBlogData): SchoolDetailBlogInputType => ({
    title: schoolBlogData.title,
    text: schoolBlogData.text,
    image: null,
    deletingImage: false,
});